import { render, staticRenderFns } from "./ViewInfo.vue?vue&type=template&id=2358937f&"
import script from "./ViewInfo.vue?vue&type=script&lang=js&"
export * from "./ViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports